import types from '../actions/types'

const { FETCH_EC_CONTESTATIONS } = types

function ecContestations(state = [], action = {}) {
  switch (action.type) {
    case FETCH_EC_CONTESTATIONS: {
      return action.state
    }

    default:
      return state
  }
}

export default ecContestations



// WEBPACK FOOTER //
// ./src/alelo-logic/reducers/ecContestations.js